"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const waitForBridge = new Promise((resolve, reject) => {
    window.appVersion = window.appVersion || 1;
    const interval = setInterval(() => {
        if (window.webViewBridgeReady) {
            clearInterval(interval);
            pingInterval = setInterval(() => {
                if (navigator.userAgent == 'Coindirect App 2.0') {
                    window.ReactNativeWebView.postMessage(JSON.stringify({ targetFunc: 'ping' }));
                }
                else {
                    window.postMessage(JSON.stringify({ targetFunc: 'ping' }));
                }
            }, 100);
            setupMessageListener(resolve);
        }
        if (window.isApp == false) {
            clearInterval(interval);
            clearInterval(pingInterval);
        }
    }, 100);
});
let pingInterval = null;
let promiseChain = waitForBridge;
const promises = {};
const callbacks = {};
const setupMessageListener = (next) => {
    if (navigator.userAgent == 'Coindirect App 2.0') {
        window.addEventListener('message', e => messageListener(e, next));
    }
    else {
        window.document.addEventListener('message', e => messageListener(e, next));
    }
};
const messageListener = (e, next) => {
    if (!e.data) {
        console.error('failed to parse message from react-native ');
        return;
    }
    //sometimes we pick up msgs from webpack, ignore them
    if (e.data && e.data.type && e.data.type == 'webpackOk') {
        return;
    }
    if (e.data == 'pong') {
        clearInterval(pingInterval);
        getDeviceName();
        next('ready');
        return;
    }
    let message;
    if (navigator.userAgent == 'Coindirect App 2.0') {
        message = e.data;
    }
    else {
        try {
            message = JSON.parse(e.data);
        }
        catch (err) {
            console.error('failed to parse message from react-native ' + err);
            return;
        }
    }
    //resolve promise - send next message if available
    if (promises[message.msgId]) {
        promises[message.msgId].resolve();
        delete promises[message.msgId];
    }
    //trigger callback
    if (message.args && callbacks[message.msgId]) {
        if (message.isSuccessfull) {
            callbacks[message.msgId].onsuccess &&
                callbacks[message.msgId].onsuccess.apply(null, message.args);
        }
        else {
            callbacks[message.msgId].onerror && callbacks[message.msgId].onerror.apply(null, message.args);
        }
        delete callbacks[message.msgId];
    }
};
const guid = () => {
    const s4 = () => {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};
const getDeviceName = () => {
    WebViewBridge.send('getDeviceName', {}, (res) => {
        WebViewBridge.deviceName = res;
    }, (err) => {
        console.error('Failed to get device name');
    });
};
const WebViewBridge = {
    /**
     * send message to the React-Native WebView onMessage handler
     * @param targetFunc - name of the function to invoke on the React-Native side
     * @param data - data to pass
     * @param success - success callback
     * @param error - error callback
     */
    send: (targetFunc, data, success, error) => {
        const msgObj = {
            msgId: guid(),
            targetFunc: targetFunc,
            data: data || {},
        };
        const msg = JSON.stringify(msgObj);
        promiseChain = promiseChain
            .then(() => {
            return new Promise(function (resolve, reject) {
                promises[msgObj.msgId] = { resolve: resolve, reject: reject };
                callbacks[msgObj.msgId] = {
                    onsuccess: success,
                    onerror: error,
                };
                if (navigator.userAgent == 'Coindirect App 2.0') {
                    window.ReactNativeWebView.postMessage(msg);
                }
                else {
                    window.postMessage(msg);
                }
            });
        })
            .catch(function (e) {
            console.error('rnBridge send failed ' + e.message);
        });
    },
    deviceName: 'Coindirect App',
    appsFlyerId: null,
    appsFlyerAppId: null,
    advertisingId: null,
    appPlatform: null,
    versionOk: (targetVersion) => {
        return window.appVersion >= targetVersion;
    },
};
exports.default = WebViewBridge;
//# sourceMappingURL=webViewBridge.js.map